import SimpleDate from "app/common/classes/simple-date";
import toFixedValue from "app/common/lib/toFixedValue";
import { ApiRowEncashment, ApiRowSummary, ApiStatusesType, dateTimeFormat, statusParams } from ".";
import { EncashmentsSummaryType, EncashmentsStatusType, EncashmentsDetailsType, StatusesType, isEncashmentsStatusType } from "app/dataTypes/reports/data";

export const getStatusKey = (keyStatus: number): EncashmentsStatusType | null => {
  const newKey = statusParams[keyStatus.toString() as keyof typeof statusParams];
  if (isEncashmentsStatusType(newKey)) {
    return newKey
  }
  return null
}
export const convertStatuses = (apiStatuses: ApiStatusesType) => {
  return Object.entries(apiStatuses).reduce((acc, [key, value]) => {
    const newKey = statusParams[key as keyof typeof statusParams];
    if (isEncashmentsStatusType(newKey)) {
      acc[newKey] = toFixedValue(value);
    }
    return acc;
  }, {} as StatusesType);
}

export const converRowSummary = (apiRowSummary: ApiRowSummary): EncashmentsSummaryType => {
  const {
    school_id: schoolId,
    school_title: schoolTitle,
    building_title: buildingTitle,
    sale_point_id: salePointId,
    sale_point_title: salePointTitle,
    status,
    comment,
    balance_at_the_beginning: balanceAtTheBeginning,
    revenue,
    collected,
    balance_at_the_end: balanceAtTheEnd,
    encashments_count: encashmentsCount
  } = apiRowSummary
  return {
    schoolId: schoolId.toString(),
    schoolTitle,
    buildingTitle,
    salePointId: salePointId.toString(),
    salePointTitle,
    status: getStatusKey(status),
    comment,
    balanceAtTheBeginning: toFixedValue(balanceAtTheBeginning),
    revenue: toFixedValue(revenue),
    collected: toFixedValue(collected),
    balanceAtTheEnd: toFixedValue(balanceAtTheEnd),
    encashmentsCount,
  }
}

export const converRowEncashments = (apiRowEncashments: Array<ApiRowEncashment>): Array<EncashmentsDetailsType> => {
  return apiRowEncashments.map(EncashmentItem => {
    const {
      id,
      time,
      balance_at_the_beginning: balanceAtTheBeginning,
      revenue,
      collected,
      balance_at_the_end: balanceAtTheEnd
    } = EncashmentItem
    return {
      id: id.toString(),
      time: new SimpleDate(time, dateTimeFormat),
      balanceAtTheBeginning: toFixedValue(balanceAtTheBeginning),
      revenue: toFixedValue(revenue),
      collected: toFixedValue(collected),
      balanceAtTheEnd: toFixedValue(balanceAtTheEnd),
    }
  })
}
